<template>
    <div class="row">
        <div class="span8">
            <checkbox-switch v-model="val2">
                {{ label }}
            </checkbox-switch>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'

    import { CheckboxSwitch } from 'vue-nani-kore'
    Vue.component('checkbox-switch', CheckboxSwitch)

    export default {
        name: 'block-check',
        props: {
            label: {
                type: String,
                required: true
            },
            index: {
                type: Number,
                required: true
            },
            val: {
                type: Boolean,
                required: true
            }
        },
        data() {
            return {
                val2: this.val
            }
        },
        watch: {
            val2() {
                var self = this;
                self.$emit('update:val', self.val2);
            }
        },
        methods: {
        }
    }
</script>


// WEBPACK FOOTER //
// _block-check.vue?30de8410